module.exports = __webpack_public_path__ + "static/media/mh_entrium_02.4d0bbfda.png";